import React from 'react';

import {
  HeaderIconStyled,
  HeaderStyled,
  HeaderTextStyled,
} from './Header.styled';

export interface HeaderProps {
  size?: 'xsmall' | 'small' | 'medium';
  spacing?: 'small' | 'medium';
  children: React.ReactNode;
}

export const Header: React.FC<HeaderProps> & {
  Icon: typeof HeaderIconStyled;
  Text: typeof HeaderTextStyled;
} = ({ size, spacing, children }: HeaderProps) => {
  return (
    <HeaderStyled spacing={spacing} size={size}>
      {children}
    </HeaderStyled>
  );
};

Header.Icon = HeaderIconStyled;
Header.Text = HeaderTextStyled;
